// IMPORT
import React from "react";

// CSS
import './Home.css'

// Images Sectors
import ImgSector1 from '../global/images/Bakery.jpg'
import ImgSector2 from '../global/images/Gastromomie.png'
import ImgSector3 from '../global/images/Gesundheitswesen.png'
import ImgSector4 from '../global/images/Großhandel.jpg'
import ImgSector5 from '../global/images/Apotheke.png'
import ImgSector6 from '../global/images/Lebensmittelproduzenten.png'
import ImgSector7 from '../global/images/LEH.png'
import ImgSector8 from '../global/images/Maschinen_und_Anlagenbau.png'
import ImgSector9 from '../global/images/Postdienstleister.png'
import ImgSector10 from '../global/images/Transportlogistik.png'
import ImgSector11 from '../global/images/Workwear.png'

// Components
import TeaserPlattform from '../../components/Teaser/TeaserPlattform.jsx'
import TeaserSectors from '../../components/Teaser/TeaserSectors.jsx'
import TeaserMembership from '../../components/Teaser/TeaserMembership.jsx'
import CompCallToAction from "../../components/CompCallToAction.jsx";
import CompCustomerLogos from "../../components/CompCustomerLogos.jsx";
import CompHeadingImageGalery from "../../components/CompHeadingImageGalery.jsx";

// Home
export default function Home() {
  const sectorImages = [
    {
      original: ImgSector1,
      originalWidth: "100%",
    },
    {
      original: ImgSector2,
      originalWidth: "100%",
    },
    {
      original: ImgSector3,
      originalWidth: "100%",
    },
    {
      original: ImgSector4,
      originalWidth: "100%",
    },
    {
      original: ImgSector5,
      originalWidth: "100%",
    },
    {
      original: ImgSector6,
      originalWidth: "100%",
    },
    {
      original: ImgSector7,
      originalWidth: "100%",
    },
    {
      original: ImgSector8,
      originalWidth: "100%",
    },
    {
      original: ImgSector9,
      originalWidth: "100%",
    },
    {
      original: ImgSector10,
      originalWidth: "100%",
    },
    {
      original: ImgSector11,
      originalWidth: "100%",
    },
  ];

  return (
    <div className="Home-Content landingpage-gap">
      <CompHeadingImageGalery
        Title={"Die intelligente Planungsplattform"}
        Images={sectorImages}
      />
      {/*       <TeaserPlattform
        Title={"Die intelligente Planungsplattform"}
        Subheading={"Mit unseren KI-Lösungen setzen Sie neue Maßstäbe in Ihrer Planung."}
        Graphic={GraphicPlanningPlattform}
        GraphicAlt={"Die intelligente Planungsplattform"}
        ButtonLink={"/solutions"}
      /> */}
      <CompCustomerLogos
        Title={"Kunden"}
      />
      <div className="Home-Video">
        <video src="https://portal.aixioom.de/public.php/dav/files/nFnQoTLLEdja8xb/" loading="visible" controls preload="true" />
      </div>
      <TeaserSectors />
      <CompCallToAction
        Title={"Starten Sie noch heute mit Aixioom"}
        Subheading={"Kontaktieren Sie jetzt eine(n) unserer Expert*innen und fordern Sie eine individuelle Demo an."}
        ButtonText={"Kontakt"}
        ButtonLink={"/contact"}
      />
      <TeaserMembership
        Title={"Mitglied im"}
      />
    </div>
  )
}
